import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@mui/material";
import secureLocalStorage from "react-secure-storage";

const ActionButtons = () => {
  const settings = secureLocalStorage.getItem("systemSettings");
  const settingsInfo = JSON.parse(settings);
  const mainBackground = settingsInfo?.mainBackground;

  const location = useLocation(); // Get the current route

  const isMeetingActive = location.pathname === "/admin/meeting";
  const isMinutesActive = location.pathname === "/admin/minutes";

  return (
    <div className="flex gap-2">
      <Link to="/admin/meeting" className="text-decoration-none">
        <Button
          style={{
            backgroundColor: isMeetingActive ? mainBackground: "white",
            color: isMeetingActive ? "white" : mainBackground,
          }}
          variant="contained"
          size="small"
        >
          <i className="fa fa-calendar fa-md me-1" />
          <span className="ml-2">Meeting</span>
        </Button>
      </Link>
      <Link to="/admin/minutes" className="text-decoration-none">
        <Button
          style={{
            backgroundColor: isMinutesActive ? mainBackground: "white",
            color: isMinutesActive ? "white" : mainBackground,
          }}
          variant="contained"
          size="small"
        >
          <i className="fa fa-users fa-md me-1" />
          <span className="">Minutes</span>
        </Button>
      </Link>
    </div>
  );
};

export default ActionButtons;